import gameSerializer from '@serializers/gameSerializer.js'
import { computed, ref } from 'vue'

const gameRef = ref(undefined)

export default function () {
  function getPublicGame(refresh = false) {
    if (!gameRef.value || refresh) {
      gameRef.value = globalThis.GAME
        ? gameSerializer.transform(globalThis.GAME)
        : null
    }
    return computed(() => gameRef.value)
  }

  return {
    getPublicGame,
  }
}
